import { Subject } from 'rxjs'

export const UserChartSynced = new Subject<void>()
